export const FAQ_ASK_PATH = "/faq/ask";
export const FAQ_QUESTION_MIN_LENGTH = 8;
export const FAQ_QUESTION_MAX_LENGTH = 300;

export const FAQ_ASK_REFUSALS = [
  "invalid_request",
  "rate_limited",
  "busy",
  "blocked",
] as const;

export type FaqAskRefusal = (typeof FAQ_ASK_REFUSALS)[number];

export const FAQ_ASK_OUTCOMES = ["answered", "not_on_listing", "no_answer"] as const;

export type FaqAskOutcomeKind = (typeof FAQ_ASK_OUTCOMES)[number];

export type FaqAskEvent =
  | { type: "delta"; text: string }
  | { type: "replace"; text: string }
  | {
      type: "done";
      questionId: string;
      isGrounded: boolean;
      outcome: FaqAskOutcomeKind;
      /** @deprecated Always empty. Remove once the production Worker no longer requires it in a done event (the release after TKT-004806). */
      sources: [];
    }
  | { type: "error" };
